
  <section class="page-banner-sec" [style.background-image]="'url(' + (pageData?.image ? pageData?.image  :'assets/img/investor-page-banner.png') + ')'">
    <div class="container">
        <h1 class="page-banner-title">{{pageData?.title }}</h1>
    </div>
  </section>

  <section class="py-5">
     <div class="container">
          <div  class="text-76" [innerHtml]="pageData?.description"></div>
         
         <div class="row two-part-img-text my-5">
             <div class="col-lg-6"><div class="part-img">
                 <img [src]="pageData?.jsonKey[0]?.content[0]?.image? pageData?.jsonKey[0]?.content[0]?.image:'assets/img/our-mission-in.png'" class="img-responsive">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="part-text">
                 <h2 class="font-weight-bold">{{pageData?.jsonKey[0]?.content[0]?.title}}</h2>
                  <div  class="text-76" [innerHtml]="pageData?.jsonKey[0]?.content[0]?.description"></div>
 
                </div>
            </div>
        </div>
     </div>
  </section>

  <section class="py-5 invetor-news-event-sec">
     <div class="container">
        <h2 class="font-weight-bold text-center mb-3">News & Events</h2>
        <div class="row">

            <div class="col-xl-3 col-sm-6" *ngFor="let item of newsAndEvent">
                <div class="in-event-box">
                    <div class="in-event-img">
                        <img [src]="item.image">
                    </div>
                    <div class="in-event-text">
                        <span class="date">{{item.createdAt | date :'fullDate'}}</span>
                        <h3>{{item?.title}}</h3>
                        <p style="text-align: justify;">{{item?.description.length < 100 ? item.description : item.description.slice(0,100)+'...'}}</p>
                        <!-- <P [ngClass]="{'limitTextHeight': isReadMore}" *ngIf="!isReadMore" >{{text | slice:0:50}}...</P> -->
                        <!-- <p [ngClass]="{'limitTextHeight': isReadMore}" *ngIf="isReadMore">{{text}}</p> -->
                        
                        <!-- <a href="javascript:void(0);" (click)="isReadMore=!isReadMore">{{ isReadMore ? 'Read Less': 'Read More' }} -->
                        <a [routerLink]="['/news-detail',item._id]">Read More</a>
                        
                    </div>
                </div>
            </div>
            <!-- <div class="col-xl-3 col-sm-6">
                <div class="in-event-box">
                    <div class="in-event-img">
                        <img src="assets/img/event-car.png">
                    </div>
                    <div class="in-event-text">
                        <span class="date">18 October</span>
                        <h3>Lorem ipsum dollar sit amet</h3>
                        <P [ngClass]="{'limitTextHeight1': isReadMore1}" *ngIf="!isReadMore1" >{{text | slice:0:50}}...</P>
                        <p [ngClass]="{'limitTextHeight1': isReadMore1}" *ngIf="isReadMore1">{{text}}</p>
                        <a href="javascript:void(0);" (click)="isReadMore1=!isReadMore1">{{ isReadMore1 ? 'Read Less': 'Read More' }}
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-sm-6">
                <div class="in-event-box">
                    <div class="in-event-img">
                        <img src="assets/img/event-car.png">
                    </div>
                    <div class="in-event-text">
                        <span class="date">18 October</span>
                        <h3>Lorem ipsum dollar sit amet</h3>
                        <P [ngClass]="{'limitTextHeight2': isReadMore2}" *ngIf="!isReadMore2" >{{text | slice:0:50}}...</P>
                        <p [ngClass]="{'limitTextHeight2': isReadMore2}" *ngIf="isReadMore2">{{text}}</p>
                        <a href="javascript:void(0);" (click)="isReadMore2=!isReadMore2">{{ isReadMore2 ? 'Read Less': 'Read More' }}
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-sm-6">
                <div class="in-event-box">
                    <div class="in-event-img">
                        <img src="assets/img/event-car.png">
                    </div>
                    <div class="in-event-text">
                        <span class="date">18 October</span>
                        <h3>Lorem ipsum dollar sit amet</h3>
                        <P [ngClass]="{'limitTextHeight3': isReadMore3}" *ngIf="!isReadMore3" >{{text | slice:0:50}}...</P>
                        <p [ngClass]="{'limitTextHeight3': isReadMore3}" *ngIf="isReadMore3">{{text}}</p>
                        <a href="javascript:void(0);" (click)="isReadMore3=!isReadMore3">{{ isReadMore3 ? 'Read Less': 'Read More' }}
                        </a>
                    </div>
                </div>
            </div> -->

        </div>
     </div>
  </section>
<!-- 
  <section class="py-5 invetor-finance-results-sec">
    <div class="container">
       <h2 class="font-weight-bold text-center mb-3">Finance Results</h2>
       <h3 class="font-weight-bold text-center mb-3 text-white">Q 2 - 2020</h3>
       <div class="row">

        <div class="col-xl-3 col-sm-6 my-3">
            <div class="fr-box">
                <img src="assets/img/fr-icon-pdf.png">
                Wooffer Second Quarter 2020 <br/>
Earnings Call
            </div>
        </div>
        <div class="col-xl-3 col-sm-6 my-3">
            <div class="fr-box">
                <img src="assets/img/fr-icon-speaker.png">
                Wooffer Announces Second <br/>
                Quarter Results
            </div>
        </div>
        <div class="col-xl-3 col-sm-6 my-3">
            <div class="fr-box">
                <img src="assets/img/fr-icon-data.png">
                Wooffer Q2 2020 Earnings <br/>
Supplemental Data
            </div>
        </div>
        <div class="col-xl-3 col-sm-6 my-3">
            <div class="fr-box">
                <img src="assets/img/fr-icon-form.png">
                Form 10-Q
            </div>
        </div>

       </div>
    </div>
</section> -->
